import type { InjectionKey } from 'vue'
import type { BackendClients } from '~/api/backendClients'
import type { SwitchingPremiseChecker } from '~/api/switchingPremiseChecker'
import type { WebsocketClient } from '~/api/websocket'
import type { ServerClient } from '~/api/serverClient'

export const BackendClientKey = Symbol.for('backend') as InjectionKey<BackendClients>
export const PremiseCheckerKey = Symbol.for('PremiseCheckerKey') as InjectionKey<SwitchingPremiseChecker>
export const WebsocketClientKey = Symbol.for('WebsocketClientKey') as InjectionKey<WebsocketClient>
export const ServerClientKey = Symbol.for('ServerClientKey') as InjectionKey<ServerClient>
